import UserProvider from './src/providers/UserProvider'

export const wrapRootElement = UserProvider
